import { render, staticRenderFns } from "./SuCashApp.vue?vue&type=template&id=62088efa&scoped=true"
import script from "./SuCashApp.vue?vue&type=script&lang=js"
export * from "./SuCashApp.vue?vue&type=script&lang=js"
import style0 from "./SuCashApp.vue?vue&type=style&index=0&id=62088efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62088efa",
  null
  
)

export default component.exports